// @services/clients/StatementClassifierRoutes.ts

export const StatementClassifierRoutes = {
    submitJob: "/v1/expense/statement-classifier/jobs",
    jobStatus: "/v1/expense/statement-classifier/jobs/{jobId}",
    preview: "/v1/expense/statement-classifier/jobs/{jobId}/preview",
    workbook: "/v1/expense/statement-classifier/jobs/{jobId}/workbook",
} as const;

export const statementClassifierRouteForJob = (
    route: typeof StatementClassifierRoutes.jobStatus
        | typeof StatementClassifierRoutes.preview
        | typeof StatementClassifierRoutes.workbook,
    jobId: string,
): string => route.replace("{jobId}", encodeURIComponent(jobId));
